/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useHistory } from 'react-router-dom';

interface IProps {
  title: string;
}
export const MapHeader:React.FC<IProps> = ({ title }) => {
  const { goBack } = useHistory();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      gap: '12px',
    }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          border: 'none',
          padding: '0',

        }}
        onClick={() => goBack()}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.6666 8H3.33325" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.99992 12.6666L3.33325 7.99998L7.99992 3.33331" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      </div>
      <div style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      >
        <div>
          <h2 style={{
            color: '#190952',
            fontSize: '24px',
            fontWeight: '600',
            maxWidth: '100%',
            overflowWrap: 'break-word',
            lineHeight: '0',
          }}
          >
            {title}
          </h2>
        </div>
      </div>
    </div>
  );
};
